import { createFileRoute } from '@tanstack/react-router'

import { casesSearchSchema } from '@/features/cases/cases-search'
import { CasesPage } from '@/features/cases/cases-page'

export const Route = createFileRoute('/cases')({ validateSearch: casesSearchSchema, component: CasesPage })
